module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('div', {
    attrs: {
      "aria-label": "2",
      "epub:type": "pagebreak",
      "id": "page2",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left-opener"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Velvet Comet ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("spun slowly in space, resembling nothing more than a giant barbell. Its metal skin glistened a brilliant silver, and its array of flashing lights could be seen from literally tens of thousands of miles away. ")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Seventeen different engineering firms had worked on its design, thousands of men and machines had spent millions of hours on its construction, and it housed a permanent staff of more than six hundred men and women. Owned and financed by the Vainmill Syndicate, the largest of the Republic’s conglomerates, it had been built in orbit around the distant planet of Charlemagne, but now it circled Deluros VIII, the huge world that would someday become the capital planet of the race of Man. ")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("During its eighty-seven years of existence it had become a byword for opulence and elegance, a synonym for hedonism and dissipation. Its fame had spread to the most remote worlds of the Republic, and while its sybaritic luxuries and even its air of exclusivity were often imitated, they were never equaled. ")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Velvet Comet")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(", after more than three decades of gestation, had been born in space, and less than a century after its birth it would die in space, mourned by few and forgotten by most. But in the meantime, it did its living with a grace and style that would not be seen again for many millennia. ")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("It was the crown jewel in the Syndicate’s Entertainment and Leisure Division, a showplace where the rich and the famous—and occasionally the notorious—gathered to see and be seen, to conspicuously consume, and to revel in pleasures which were designed to satisfy even the most jaded of tastes. For while the ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Velvet Comet")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" housed a compendium of the finest shops and boutiques, of gourmet restaurants and elegant lounges, while it boasted a fabulous casino and a score of other entertainments, it was first and foremost a brothel. ")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("And it was the brothel, and the promises of secret delights that it proffered, that enticed its select clientele out to the ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Comet")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(". They came from Deluros VIII and a thousand nearby and distant worlds. Money was no object to these men and women; they came to play, and to relax, and to indulge. ")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("All except one of them, who came with one purpose in mind, and left with another. ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-103c30a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErosDescending-2.vue
// module id = 69
// module chunks = 0